import { parse } from 'query-string';
import Cookies from 'universal-cookie';
import { tourlaneDomainRegExp, getDomain } from './common';
/**
 * Sets "channel" and "gclid" cookie (to root domain) equal to "ch" and gclid search param respectively,
 * if document.referrer is external application or empty.
 *
 * E.g. user comes from facebook ad:
 *   referrer=facebook.com
 *   location=tourlane.de?ch=facebook&gclid=12345
 * we'll set set channel cookie equal to "facebook" and gclid cookie to "12345".
 *
 * User open tourlane.de from bookmarks:
 *   referrer=""
 *   location=tourlane.de
 * we'll set set cookie equal to "".
 *
 * The value of cookie is later used for conversion event in Google Tag Manager to implement "last click attribution" -
 * a web analytics model in which “last click” is given credit.
 */

export var setMarketingCookies = function setMarketingCookies() {
  var rootPath = '/';

  var _document$referrer$sp = document.referrer.split(rootPath),
      referrerHost = _document$referrer$sp[2];

  if (!tourlaneDomainRegExp.test(referrerHost)) {
    var cookies = new Cookies();

    var _parse = parse(window.location.search.substr(1)),
        _parse$ch = _parse.ch,
        ch = _parse$ch === void 0 ? '' : _parse$ch,
        _parse$gclid = _parse.gclid,
        gclid = _parse$gclid === void 0 ? '' : _parse$gclid;

    var domain = getDomain();
    cookies.set('channel', ch, {
      domain: domain,
      path: rootPath
    });
    cookies.set('gclid', gclid, {
      domain: domain,
      path: rootPath
    });
  }
};